export const headers = [
  {
    key: '',
    i18n: 'ACCESS_KEY',
    centerTitle: true,
  },
  {
    order: true,
    key: 'display_name',
    i18n: 'COMPANY_NAME_KEY',
  },
  {
    order: true,
    key: 'num_partners',
    i18n: 'PARTNERS_KEY',
    centerTitle: true,
  },
  {
    order: true,
    key: 'num_environments',
    i18n: 'ENVIRONMENTS_KEY',
    centerTitle: true,
  },
  {
    order: true,
    key: 'num_clients',
    i18n: 'CLIENTS_KEY',
    centerTitle: true,
  },
  {
    order: true,
    key: 'num_users',
    i18n: 'USERS_KEY',
    centerTitle: true,
  },
  {
    key: 'portal_deleted',
    i18n: 'STATUS_KEY',
    order: true,
    centerTitle: true,
  },
];
